module.exports = __webpack_public_path__ + "media/images/nestle-logo-19ebc913872673c817bead4ea9fdc74e.svg";